import { createMuiTheme } from '@material-ui/core/styles';

const MuiTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#212529 !important',
    },
    error: {
      main: '#ce0527 !important',
    },
  },
});

export default MuiTheme;
